const defaultStatusList = [
    { id:'', label:'Todos', color:'#9C27B0', total:'0', icon:'ArchiveIcon', active:true },
    { id:'1', label:'Recibidos', color:'#E0E0E0', total:'0', icon:'PackageIcon', active:false },
    { id:'13', label:'Rechazados', color:'#E0E0E0', total:'0', icon:'AlertTriangleIcon', active:false },
    { id:'0', label:'Cancelados', color:'#E0E0E0', total:'0', icon:'XIcon', active:false },
    { id:'2', label:'Pendientes', color:'#E0E0E0', total:'0', icon:'ClockIcon', active:false },
    { id:'4', label:'Aprobados', color:'#E0E0E0', total:'0', icon:'CheckIcon', active:false },
    { id:'6', label:'Por Pagar', color:'#E0E0E0', total:'0', icon:'FileIcon', active:false },
    { id:'7', label:'Pagados', color:'#E0E0E0', total:'0', icon:'DollarSignIcon', active:false }
]

export default defaultStatusList